// extracted by mini-css-extract-plugin
export default {"Modal":"QgcxkU1uuJYnB6MkRfAH","ModalFooter":"e8MG4_qeAL_Co1TmwWhA","ModalCancelButton":"lWC9lXpg8bg33MQFYlcH"};